<template>
  <ul class="former-container">
    <slot />
  </ul>
</template>

<script>
  export default {
    name: 'FormerContainer',
  };
</script>

<style lang="scss" scoped>
  .former-container {
    list-style: none;
  }
</style>
